import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

interface DeleteReportPayload {
  reportId: string;
}

export const deleteReport = createAsyncThunk(
  'deleteReport',
  async (payload: DeleteReportPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const res = await fetch(`${REPORTS?.DELETE_REPORT_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to delete report');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
